import * as S from "./styled"
import { formatMoney } from "../../utils/tb/formatMoney"
import { TTicketDisposal } from "../../utils/@types/data/ticket"
import { ReactComponent as CheckIcon } from "../../assets/icons/check_circle.svg"

type Props = {
  product: TTicketDisposal
  mesaType: "mesa" | "camarote"
  selected: boolean
  onClick: () => void
}

const MesaOption = ({ product, mesaType, selected, onClick }: Props) => {
  const soldOut = product.quantity === 0
  const label = `${mesaType === "mesa" ? "Mesa" : "Camarote"} ${product.mesa_number}`

  return (
    <S.Component
      type="button"
      $selected={selected}
      $soldOut={soldOut}
      disabled={soldOut}
      onClick={soldOut ? undefined : onClick}
      aria-pressed={selected}
    >
      <S.Info>
        <S.Name>
          {label}
          {product.mesa_seats != null && (
            <S.Seats> — {product.mesa_seats} lugares</S.Seats>
          )}
        </S.Name>
      </S.Info>
      {soldOut ? (
        <S.SoldOut>Esgotado</S.SoldOut>
      ) : (
        <S.PriceArea>
          <S.Price>{formatMoney(product.price_sell, true)}</S.Price>
          {selected && (
            <CheckIcon
              data-testid="mesa-option-check"
              width={20}
              height={20}
            />
          )}
        </S.PriceArea>
      )}
    </S.Component>
  )
}

export default MesaOption
